/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ResetOnboardingDialog.vue?vue&type=template&id=31417ee1"
import script from "./ResetOnboardingDialog.vue?vue&type=script&lang=js"
export * from "./ResetOnboardingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31417ee1')) {
      api.createRecord('31417ee1', component.options)
    } else {
      api.reload('31417ee1', component.options)
    }
    module.hot.accept("./ResetOnboardingDialog.vue?vue&type=template&id=31417ee1", function () {
      api.rerender('31417ee1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/ResetOnboardingDialog.vue"
export default component.exports